import { css } from '@microsoft/fast-element';
import { agGridCSS } from './ag-grid-css';
import { agHeadCSS } from './ag-head-css';
import { agThemeAlpineNofontsCSS } from './ag-theme-alpine-no-font-css';
import { agThemeBalhamNofontsCSS } from './ag-theme-balham-no-font-css';
import { agThemeMaterialNofontsCSS } from './ag-theme-material-no-font-css';
export * from './fonts';
/**
 * All External AG Grid Stock in one CSS.
 * @remarks This is a collection of multiple AG themes, only needed if the target element needs more than one stock theme.
 * @public
 */
export const agExternalStockStyles = css `
  ${agGridCSS}
  ${agHeadCSS}
  ${agThemeAlpineNofontsCSS}
  ${agThemeBalhamNofontsCSS}
  ${agThemeMaterialNofontsCSS}
`;
/**
 * All available External AG Grid Stock CSS.
 * @public
 */
export { agGridCSS, agHeadCSS, agThemeAlpineNofontsCSS, agThemeBalhamNofontsCSS, agThemeMaterialNofontsCSS, };
